import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { apiGetBlockedRequests } from "../../../api/developer-api/api-call-get-blocked-requests";
import {
  TBlockRequestsAll,
  TBlockRequestsData,
  TBlockRequestsDetails
} from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { isPositiveNumber, reduce } from "et3-type-guards";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class BlockedRequestStore {
  blockRequestsData = observable.box<TBlockRequestsData>([]);
  blockRequestsDetails = observable.box<TBlockRequestsDetails>([]);
  limit = observable.box<TEt3PickerSingleValue>({
    label: "5",
    value: "5"
  });

  setBlockedRequests = (data: TBlockRequestsAll) => {
    runInAction(() => {
      const blockRequestsData = data.blockRequestsData;
      this.blockRequestsData.set(blockRequestsData);

      const blockRequestsDetails = data.blockRequestsDetails;
      this.blockRequestsDetails.set(blockRequestsDetails);
    });
  };

  setLimit = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.limit.set(limit);
    });
  };

  getBlockedRequests = async () => {
    const definedLimit = reducerToZeroIfUndefined(
      parseInt(this.limit.get().value, 10)
    );
    if (!isPositiveNumber(definedLimit)) {
      return;
    }
    getCoreUIStore().setIsLoading("DEVELOPER_BLOCKED_REQUESTS", true);
    const { status, code, data } = await apiGetBlockedRequests(definedLimit);
    getCoreUIStore().setIsLoading("DEVELOPER_BLOCKED_REQUESTS", false);
    if (status === "OK") {
      const blockRequestsData = reduce(() => data.blockRequestsData, []);
      const blockRequestsDetails = reduce(() => data.blockRequestsDetails, []);
      this.setBlockedRequests({
        blockRequestsData,
        blockRequestsDetails
      });
      return;
    }
    this.blockRequestsDetails.set([]);
    getCorePopUpStore().showAlertMessage(code);
  };
}
const getBlockedRequestStore = memoize(
  () => new BlockedRequestStore(),
  () => 1
);
export default getBlockedRequestStore;
